import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_shell/select-organization")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
});
